module.exports = __webpack_public_path__ + "img/Dustin.6aa05845.png";